import React, { CSSProperties } from 'react';

interface SvgIconEmailProps {
  style?: CSSProperties;
  color?: string;
}

const SvgIconEmail: React.FC<SvgIconEmailProps> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M12 19C11.0317 19 10.1217 18.8162 9.27 18.4488C8.41833 18.0813 7.6775 17.5825 7.0475 16.9525C6.4175 16.3225 5.91875 15.5817 5.55125 14.73C5.18375 13.8783 5 12.9683 5 12C5 11.0317 5.18375 10.1217 5.55125 9.27C5.91875 8.41833 6.4175 7.6775 7.0475 7.0475C7.6775 6.4175 8.41833 5.91875 9.27 5.55125C10.1217 5.18375 11.0317 5 12 5C12.9683 5 13.8783 5.18375 14.73 5.55125C15.5817 5.91875 16.3225 6.4175 16.9525 7.0475C17.5825 7.6775 18.0813 8.41833 18.4488 9.27C18.8162 10.1217 19 11.0317 19 12V13.015C19 13.7033 18.7638 14.2896 18.2913 14.7738C17.8188 15.2579 17.2383 15.5 16.55 15.5C16.1417 15.5 15.7567 15.4125 15.395 15.2375C15.0333 15.0625 14.73 14.8117 14.485 14.485C14.1467 14.8233 13.7646 15.0771 13.3387 15.2463C12.9129 15.4154 12.4667 15.5 12 15.5C11.0317 15.5 10.2063 15.1587 9.52375 14.4762C8.84125 13.7937 8.5 12.9683 8.5 12C8.5 11.0317 8.84125 10.2063 9.52375 9.52375C10.2063 8.84125 11.0317 8.5 12 8.5C12.9683 8.5 13.7937 8.84125 14.4762 9.52375C15.1587 10.2063 15.5 11.0317 15.5 12V13.015C15.5 13.3183 15.5992 13.575 15.7975 13.785C15.9958 13.995 16.2467 14.1 16.55 14.1C16.8533 14.1 17.1042 13.995 17.3025 13.785C17.5008 13.575 17.6 13.3183 17.6 13.015V12C17.6 10.4367 17.0575 9.1125 15.9725 8.0275C14.8875 6.9425 13.5633 6.4 12 6.4C10.4367 6.4 9.1125 6.9425 8.0275 8.0275C6.9425 9.1125 6.4 10.4367 6.4 12C6.4 13.5633 6.9425 14.8875 8.0275 15.9725C9.1125 17.0575 10.4367 17.6 12 17.6H15.5V19H12ZM12 14.1C12.5833 14.1 13.0792 13.8958 13.4875 13.4875C13.8958 13.0792 14.1 12.5833 14.1 12C14.1 11.4167 13.8958 10.9208 13.4875 10.5125C13.0792 10.1042 12.5833 9.9 12 9.9C11.4167 9.9 10.9208 10.1042 10.5125 10.5125C10.1042 10.9208 9.9 11.4167 9.9 12C9.9 12.5833 10.1042 13.0792 10.5125 13.4875C10.9208 13.8958 11.4167 14.1 12 14.1Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconEmail;
